import { useMemo } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useFamily } from './useFamily';
import { APP_VIEW_ONLY_MESSAGE } from '../utils/writeAccess';

export { APP_VIEW_ONLY_MESSAGE } from '../utils/writeAccess';

/**
 * Global app write-access policy for patient/family context.
 * Viewer on another profile => read-only across app writes.
 */
export function useAppWriteAccess() {
  const { isAuthenticated, isLoading, isDoctor, user } = useAuth();
  const { familyMembers, activeUserId } = useFamily();

  const canWriteAppActions = useMemo(() => {
    if (isLoading || !isAuthenticated || user?.id == null) return true;
    if (isDoctor()) return true;
    if (!activeUserId?.trim()) return true;

    const active = familyMembers.find((m) => m.id === activeUserId);
    if (!active || active.isSelf) return true;
    return active.role !== 'viewer';
  }, [
    isLoading,
    isAuthenticated,
    user?.id,
    isDoctor,
    familyMembers,
    activeUserId,
  ]);

  return {
    canWriteAppActions,
    writeBlockedMessage: APP_VIEW_ONLY_MESSAGE,
  };
}
